import { Link, useLocation } from "react-router-dom";

export default function OrderSuccess() {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber;

  return (
    <div className="container">
      <div className="success-panel">
        <div className="check" aria-hidden="true">
          ✓
        </div>
        <h1>Thank you!</h1>
        <p>
          {orderNumber ? (
            <>
              Your order <strong>{orderNumber}</strong> has been received. We’ll contact you shortly
              to confirm.
            </>
          ) : (
            <>Your order has been received. We’ll contact you shortly to confirm.</>
          )}
        </p>
        <p className="muted">
          Pickup at 1025 Killian Hill Rd Lilburn GA, 30047 Suite C
          <br />
          +1 (404) 453-6512
        </p>
        <div className="hero-cta" style={{ justifyContent: "center", marginTop: "1.5rem" }}>
          <Link className="btn btn-primary" to="/shop">
            Continue shopping
          </Link>
          <Link className="btn btn-ghost" to="/contact">
            Contact us
          </Link>
        </div>
      </div>
    </div>
  );
}
